<template>
  <div>
    {{getparentproperty}}{{getConfirmBoxResponse}}
    <!-- <div v-if="showinvestigationpopup">  
      <InvestigationPopup ref="add-investigation" :showpopup="showinvestigationpopup"  :routeObj=this.$route @redirectUrl="viewInvesti"></InvestigationPopup>
    </div>-->
    <!-- <div v-if="showprescriptionpopup">
        <CreatePrescription :prescriptionobj="ViewPrecriptionData"></CreatePrescription>
    </div>-->
    <!-- <div v-if="showillnesspopup">
    <ProbelmsIllness v-if="this.encounter"  v-bind:isloadcimspopup="true"  v-bind:popupclicked="popupheadertext" v-bind:encuniqueid="this.encounter.unique_id"  v-bind:enccreateddate="this.encounter.created_date" v-bind:encounter_id="this.encounter.patient_encounter_number" v-on:closepopup="closeillnesspopup"  ref="ehrproblemsillness"></ProbelmsIllness>
    </div>-->
    <div>
      
      <li class="card">
        <a v-if="certificateflag"
          class="menu-title hover-effect white"
         
          v-on:click="gotoURL('/formtemplateehrlite')" v-bind:class="{'active':($router.currentRoute.path==='formtemplateehrlite')}"
        >
          <span
            class="certificate toggle-menu toggle-menu-2 tooltip-text"
            :title="$t('Certificates')"
            data-toggle="tooltip"
            data-placement="bottom"
          ></span>{{$t("Certificates")}}
        </a>
      </li>   
      <li class="px-4">
        <div class="btnhold p-0"></div>
      </li>
      <li class="card" v-if="this.thisparentproperty.saveddatetimestr">
        <a class="menu-title hover-effect global-disabled" style="color: #fff !important;    opacity: 1;">
          <span
            class="savebtn toggle-menu toggle-menu-2 tooltip-text"
            :title="thisparentproperty.saveddatetimestr? this.$t('Lastsavedat')+this.thisparentproperty.saveddatetimestr:''"
            data-toggle="tooltip"
            data-placement="right"
          ></span>
          {{$t('Lastsavedat')}} {{+" "+this.thisparentproperty.saveddatetimestr}}
        </a>
      </li>
    </div>
    <createTemplatePopup :popuptitle=templatepopuptitle :showmodal=openshowtemplate @cancelAction="openshowtemplate=false; templatepopuptitle='';"></createTemplatePopup>
    <!-- Confirm POP UP START-->
    <ConfirmBox ref="confirmcomp" :showmodal="showCnfrmPopUp" :actionmessage="actionMsg" @cancelAction="showCnfrmPopUp = false; confrmPopUpResponse = false;" @confirmAction="showCnfrmPopUp = false; confrmPopUpResponse = true;">
        <!--
            you can use custom content here to overwrite
            default content
            <h3 slot="header">{{customheadertxt}}</h3>
        -->
    </ConfirmBox>
    <!-- Confirm POP UP END-->
    <Messages :iserror="iserrormsg" :datamessage="sucessmsgtext" v-on:closemsg="closeMessage" :isVisible="isdisplaymsg"></Messages>

  </div>
</template>

<script>
import CreatePrescription from "@/components/Prescription/createprescription";
import InvestigationPopup from "@/components/Investigation/InvestigationPopup";
import ProbelmsIllness from "@/components/ProblemsIllness/ProblemsandIllness";
import rest_service from "@/api/rest_service";
import { mapActions, mapGetters, Store } from "vuex";
import createTemplatePopup from "@/components/ClinicalTemplate/createtemplate";
import Auth from "@/common/mixins";
import Axios from "axios";
import ConfirmBox from "@/components/MessagePopup/ConfirmPopup";
import Messages from "@/components/MessagePopup/Messages";
import i18n from '@/plugin/i18n';
const getCDTbyProviderAndCategory = "/clinicaldatatemplate/getcdtbyproviderandcategory";
const getCDTbyProvider = "/clinicaldatatemplate/getcdtbyprovider";


export default {
  props: ["saveddatetime", "parentprops"],
  mixins:[Auth],
  components: {
    InvestigationPopup,
    CreatePrescription,
    ProbelmsIllness,
    createTemplatePopup,
    ConfirmBox,
    Messages
  },
  data() {
    return {
      certificateflag:true,
      redirecttoInvestigationUrl: false,
      redirectFlag: false,
      selectedinvestigationmenu: false,
      selectedprescriptionmenu: false,
      selectedimmunizationnmenu: false,
      rangekey: "",
      selectedproblems: false,
      selectedFroms: false,
      showinvestigationpopup: false,
      getprescription: "",
      ViewPrecriptionData: {},
      showprescriptionpopup: false,
      showillnesspopup: false,
      range_key: "",
      encounter: "",
      billinginfoshow: false,
      thisparentproperty: null,
      templatepopuptitle:"",
      openshowtemplate:false,
      istempprocessing:false,
      clinicalTemplates:[],
      clinicalTemplatesDispArr:[],
      PatientsRecordsDispArr:[],
      templateTotal:0,
      templatepageno: 0,
      templatepageSize: parseInt(process.env.VUE_APP_CLINICAL_TEMPLATES_DEFAULT_DISPLAY_COUNT,10),
      istemplateviewmore:false,
      searchterm:"",
      highlightedlist:[],
      clipBoardText:"",
      secondaryClinicalTempaltes:"",
      showCnfrmPopUp:false,
      actionMsg:"Are you sure want to",
      showCnfrmPopUp:false,
      confrmPopUpResponse:false,
      recordToDelete:null,
      isdisplaymsg:false,
      iserrormsg:false,
      sucessmsgtext:"",
      noOfClickOnViewMore:1,
      showViewLess:false,
      showimmunization:false,
      showinvestigation:true,
      langselected:'en'  
    };
  },
  created(){
    if(this.$route.query.ip_reg_id){
     this.certificateflag=false;
    }
    if(localStorage.getItem("hmsinpatient") && localStorage.getItem("hmsinpatient") == 'true'){
      this.showinvestigation = false;
    }
    this.getClinicaltemplates("", 0, false);
    this.getPatientRecords();
  },
  updated(){
      $(function () {
      $('[data-toggle="popover"]').popover({
      placement: 'right',
      container: 'body',
      boundary:'window',
      html: true,
      content: function () {
          return $(this).next('.popper-content').html();
          
      }
      
      })
    })
    $('body').on('click', function (e) {
        $('[data-toggle=popover]').each(function () {
            // hide any open popovers when the anywhere else in the body is clicked
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('hide');
            }
        });
    });
  },
  mounted() {
    if (this.$route.query.range_key) {
      this.rangekey = this.$route.query.range_key;
    } else if (this.$route.query.encounter_id) {
      this.rangekey = this.$route.query.encounter_id;
    }
    this.GetEncounterdetails();
  },
  computed: {
    test() {
      var currentroute = this.$route.params.pathMatch;
      if (currentroute === "investigation") {
        this.selectedinvestigationmenu = true;
        this.selectedprescriptionmenu = false;
        this.selectedimmunizationnmenu = false;
        this.selectedproblems = false;
        this.selectedFroms = false;
      } else if (currentroute === "prescription") {
        this.selectedinvestigationmenu = false;
        this.selectedprescriptionmenu = true;
        this.selectedimmunizationnmenu = false;
        this.selectedproblems = false;
        this.selectedFroms = false;
      } else if (currentroute === "immunization") {
        this.selectedinvestigationmenu = false;
        this.selectedprescriptionmenu = false;
        this.selectedimmunizationnmenu = true;
        this.selectedproblems = false;
        this.selectedFroms = false;
      } else if (currentroute === "problemsillness") {
        this.selectedinvestigationmenu = false;
        this.selectedprescriptionmenu = false;
        this.selectedimmunizationnmenu = false;
        this.selectedproblems = true;
        this.selectedFroms = false;
      } else if (this.$route.name === "formtemplate") {
        this.selectedinvestigationmenu = false;
        this.selectedprescriptionmenu = false;
        this.selectedimmunizationnmenu = false;
        this.selectedproblems = false;
        this.selectedFroms = true;
      } else {
        this.selectedinvestigationmenu = false;
        this.selectedprescriptionmenu = false;
        this.selectedimmunizationnmenu = false;
        this.selectedproblems = false;
        this.selectedFroms = false;
      }
    },
    getparentproperty() {
      this.thisparentproperty = this.parentprops;
      if(this.thisparentproperty && this.thisparentproperty.parentuser && this.thisparentproperty.parentuser.category_list){
        this.thisparentproperty.parentuser.category_list.forEach(z=>{
          if(z.category === "Infectious Diseases"){
            this.showimmunization=true;
          }
        });
      }
    },
    getConfirmBoxResponse(){
      if(this.confrmPopUpResponse){
        this.deletetemplate(this.recordToDelete);
      }
      else{
        this.confrmPopUpResponse = false;
      }
    }
  },
  methods: {
    GetEncounterdetails() {
      var self = this;
      console.log("Ehr encounter Method");
      if (sessionStorage.getItem("encounterdetails")) {
        var encounterdetails = JSON.parse(
          sessionStorage.getItem("encounterdetails")
        );
        if (this.rangekey && encounterdetails) {
          if (encounterdetails.customer_id_appo_id_uniq_id) {
            console.log("Ehr encounter Method Inside length");
            if (this.rangekey == encounterdetails.customer_id_appo_id_uniq_id) {
              console.log("Ehr encounter Method Without Calling API");
              this.encounter = JSON.parse(
                sessionStorage.getItem("encounterdetails")
              );
            } else {
              console.log("Ehr encounter Method With Calling API");
              var masterdata = {
                range_key: this.rangekey,
                projectionitems: "created_date"
              };
              rest_service
                .get(
                  "/formrender/getselectedprojection",
                  localStorage.tenantid,
                  masterdata
                )
                .then(respo => {
                  if (respo.data && respo.data.result) {
                    self.encounter = respo.data.result;
                    sessionStorage.removeItem("encounterdetails");
                    sessionStorage.setItem(
                      "encounterdetails",
                      JSON.stringify(respo.data.result)
                    );
                  } else {
                    sessionStorage.setItem(
                      "encounterdetails",
                      JSON.stringify({})
                    );
                  }
                });
            }
          }
        }
      } else {
        console.log("Ehr encounter Method With Calling API Start");
        var masterdata = {
          range_key: this.rangekey,
          projectionitems: "created_date"
        };
        rest_service
          .get(
            "/formrender/getselectedprojection",
            localStorage.tenantid,
            masterdata
          )
          .then(respo => {
            if (respo.data && respo.data.result) {
              self.encounter = respo.data.result;
              sessionStorage.removeItem("encounterdetails");
              sessionStorage.setItem(
                "encounterdetails",
                JSON.stringify(respo.data.result)
              );
            } else {
              sessionStorage.setItem("encounterdetails", JSON.stringify({}));
            }
          });
      }
    },
    addillness() {
      this.showillnesspopup = true;
      this.$parent.$refs.problemsillness.clearproblemsilldata();
    },
    closeillnesspopup() {
      this.showillnesspopup = false;
    },
    showbillingdetails() {
      this.billinginfoshow = true;
      this.gotoURL("/invoicereceiptehrLite");
    },
    gotoURL(url) {      
      var rangekey;
      if (this.$route.query.range_key) {
        rangekey = this.$route.query.range_key;
      } else {
        rangekey = this.$route.query.encounter_id;
      }
      if (this.$route.query.patient_id && this.encounter) {
        this.$router.push({
          path: url,
          query: {
            range_key: rangekey,
            patient_id: this.$route.query.patient_id,
            encounter_number: this.encounter.patient_encounter_number
          }
        });
      }
    },
    Test: function() {
      if (this.encounter) this.getprescriptiondetails();
      if (!sessionStorage.getItem("prescfavoritedetails")) {
        this.getprescriptionfavorites(this.encounter);
      }
    },
    getprescriptiondetails() {
      if (sessionStorage.getItem("Prescriptionbyencounter")) {
        var prescidetails = JSON.parse(
          sessionStorage.getItem("Prescriptionbyencounter")
        );
        if (this.rangekey && prescidetails) {
          if (prescidetails.length > 0) {
            if (this.rangekey == prescidetails.encounter_id) {
              this.getprescription = JSON.parse(
                sessionStorage.getItem("Prescriptionbyencounter")
              );
              this.onCreatePrescriptions();
            } else {
              var parms = {
                customer_id: this.$route.query.patient_id,
                encounter_id: this.rangekey
              };
              rest_service
                .get(
                  "/prescription/getprescriptionsbyencounter",
                  localStorage.tenantid,
                  parms
                )
                .then(respo => {
                  if (respo.data && respo.data.result) {
                    this.getprescription = respo.data.result;
                    this.$store.state.helper.PrescriptionUpdateddetails = null;
                    sessionStorage.removeItem("Prescriptionbyencounter");
                    sessionStorage.setItem(
                      "Prescriptionbyencounter",
                      JSON.stringify(respo.data.result)
                    );
                    this.onCreatePrescriptions();
                  } else {
                    sessionStorage.setItem(
                      "Prescriptionbyencounter",
                      JSON.stringify([])
                    );
                    this.onCreatePrescriptions();
                  }
                });
            }
          } else {
            this.getprescription = JSON.parse(
              sessionStorage.getItem("Prescriptionbyencounter")
            );
            this.onCreatePrescriptions();
          }
        }
      }
    },
    onCreatePrescriptions: function() {
      this.ViewPrecriptionData = {};
      this.ViewPrecriptionData.provider_id = this.encounter.provider_id;
      this.ViewPrecriptionData.created_date = this.encounter.created_date;
      this.ViewPrecriptionData.appointment_id = this.encounter.appointment_id;
      this.ViewPrecriptionData.encounter_id = this.encounter.customer_id_appo_id_uniq_id;
      this.ViewPrecriptionData.customer_id = this.encounter.customer_id;
      this.ViewPrecriptionData.tenantId = this.encounter.tenant_id;
      this.ViewPrecriptionData.patient_encounter_number = this.encounter.patient_encounter_number;
      if (
        this.$store.state.helper &&
        this.$store.state.helper.PrescriptionUpdateddetails
      ) {
        var prescriptionlist = this.$store.state.helper
          .PrescriptionUpdateddetails;
      } else {
        var prescriptionlist = this.getprescription;
      }
      this.ViewPrecriptionData.predetails = prescriptionlist;
      this.$parent.$refs.prescriptionPopUpRefModal.showModal = true;
      // this.showprescriptionpopup = true;
      //test
    },
    getprescriptionfavorites(encounter) {
      rest_service
        .getbyid(
          "/Prescription/getfavoriteprescription",
          encounter.provider_id,
          this.tenantId,
          "?provider_id=" + encounter.provider_id
        )
        .then(respo => {
          if (respo.data) {
            if (respo.data.statusCode == 200) {
              if (respo.data.result != null || respo.data.result != undefined) {
                sessionStorage.setItem(
                  "prescfavoritedetails",
                  JSON.stringify(respo.data.result)
                );
              }
            }
          }
        });
    },
    
    viewInvesti(redirectUrl) {
      if (redirectUrl == true) {
        this.$emit("redirectUrl", true);
      }
    },
    openpriscriptionpopup(redirecttoprescription) {
      if (redirecttoprescription == true) {
        this.$emit("redirecttoprescription", true);
      }
    },

    // gotoURL(url) {
    //     // if (this.$route.query.range_key) {
    //     //   this.rangekey = this.$route.query.range_key;
    //     // } else if(this.$route.query.encounter_id){
    //     //   this.rangekey = this.$route.query.encounter_id;
    //     // }
    //     if (this.rangekey) {
    //       this.$router.push({
    //         path: url,
    //         query: {
    //           range_key: this.rangekey,
    //           patient_id: this.$route.query.patient_id
    //         }
    //       });
    //     }
    //   },
    gotoFormsURL(url) {
      if (this.rangekey) {
        this.$router.push({
          path: url
        });
      }
    },
    onCreateInvestigation: function() {
      this.showinvestigationpopup = true;
      // var params = {
      //             encounter_id: this.$route.query.range_key,
      //             patient_id: this.$route.query.range_key
      //           };
      // this.$refs.add-investigation.getinvestigationbyencounterid(params);
      //  this.$refs.add-investigation.getcategoryALLfirst(params);
    },
    gotoinvestiURL(url) {
      // if (this.$route.query.range_key) {
      //   rangekey = this.$route.query.range_key;
      // } else {
      //   rangekey = this.$route.query.encounter_id;
      // }
      if (this.$route.query.patient_id) {
        if (this.rangekey) {
          this.$router.push({
            path: url,
            query: {
              range_key: this.rangekey,
              patient_id: this.$route.query.patient_id
            }
          });
          this.redirecttoInvestigationUrl = true;
          this.$emit(
            "redirecttoInvestigationUrl",
            this.redirecttoInvestigationUrl
          );
          return false;
        }
      }
    },
    CreateImmunization(url) {
      /*
        if (this.$route.query.patient_id) {
          if (this.rangekey) {
            this.$router.push({
              path: url,
              query: {
                range_key: this.rangekey,
                patient_id: this.$route.query.patient_id
              }
            });
            this.redirectFlag = true;
            this.$emit("redirectFlag", this.redirectFlag);
            return false;
          }
        }
      */
     this.$emit("redirectFlag", true);
    },
    openCreateTemplatePopup(){
      this.templatepopuptitle="Add Template";
      this.openshowtemplate=true;
    },
    getClinicaltemplates(srckeyword, offset, isviewmore) {
      
      var user=JSON.parse(localStorage.loggedInUserInfo);
      var createduserid=user.unique_id;
      var roleid=user.role.unique_id;
      var categoryid=""; 
      
      if(user.selectedForms)
      {
        user.selectedForms.forEach(y=>{
          if(!categoryid){
            categoryid=y.unique_id;  
          }
          else{
            categoryid=categoryid+','+y.unique_id;
          }
        });
      }
      var parms = {
        category: categoryid,
        proid: createduserid,
        limit: 5,
        searchkeyword: srckeyword,
        pageoffset: offset
      };
      var self=this;
      this.istempprocessing=true;
      self.clinicalTemplates=[];
      self.secondaryClinicalTempaltes="";      
      rest_service
        .get(
          getCDTbyProvider,
          this.tenantId,
          parms
        )
        .then(responce => {         
          if (
            responce &&
            responce.data &&
            responce.data.result &&
            responce.data.result.templateList
          ) {
              /*if (isviewmore) {
                
                //When we have search with keyword highlight search word
                if (srckeyword == "") {*/               
              if(responce.data.result.templateList.length){
                responce.data.result.templateList.forEach(templates => {
                  self.clinicalTemplates.push(templates);
                });
                self.secondaryClinicalTempaltes=JSON.stringify(self.clinicalTemplates);
              /*
                  } else {
                      responce.data.result.templateList.forEach(templates => {
                      templates.name = this.highlight(templates.name, srckeyword);
                      this.clinicalTemplates.push(templates);
                    });
                  }
                } else {
                  //When we have search with keyword highlight search word
                  this.templatepageno = 0;
                  if (srckeyword != "") {
                    this.clinicalTemplates = responce.data.result.templateList;
                    this.clinicalTemplates.forEach(templates => {
                      templates.name = this.highlight(templates.name, srckeyword);
                    });
                  } else {
                    this.clinicalTemplates = responce.data.result.templateList;
                  }
                }
                this.templateTotal = responce.data.result.totalRecords;

                if (
                  this.templatepageSize < this.templateTotal &&
                  this.clinicalTemplates.length < this.templateTotal
                ) {
                  this.istemplateviewmore = true;
                  this.templatepageno = this.templatepageno + 1;
                } else {
                  this.istemplateviewmore = false;
                }
                  } else {
                    this.clinicalTemplates = null;
                    this.istemplateviewmore = false;
                  }
              */
              }
              self.showDefaultNumberOfTemplates();
            }
          }).finally(()=>{
            this.istempprocessing=false           
          });
    },
     getPatientRecords() {      
      var self = this;
      var encounterdetails = JSON.parse(sessionStorage.getItem("encounterdetails"));
      self.PatientsRecordsDispArr = [];
     var param={};
     param.scanIndexForward=false;
     if(encounterdetails && encounterdetails.customer_id_appo_id_uniq_id)
     {
       param.encounter_id=encounterdetails.customer_id_appo_id_uniq_id;
     }
     else{
       param.encounter_id=this.$route.query.range_key;
     }
      rest_service.get("/imageupload/getImagelistbyencounterid", self.tenantId, param).then(responce => {       
        if (
          responce &&
          responce.data &&
          responce.data.result &&
          responce.data.result.length > 0
        ) {
           var jsonstr = JSON.stringify(responce.data.result);
          self.staffdata = JSON.parse(jsonstr);
          let jsntr = JSON.stringify(self.staffdata);

          self.PatientsRecordsDispArr = JSON.parse(jsntr);//.slice(index,index + self.itemsPerPage);
          console.log(responce.data.result);
          console.log("Patient records LIST");
          console.log(self.PatientsRecordsDispArr);
           console.log(self.PatientsRecordsDispArr.filelist);
        
        
         
        } else {
          // self.stafflist = [];
        }
      });
    },
    showDefaultNumberOfTemplates:function(){      
      var self=this;
      self.showViewLess=false;
      self.clinicalTemplatesDispArr=[];
      if(self.secondaryClinicalTempaltes){
        var templatearr = JSON.parse(self.secondaryClinicalTempaltes);
        if(templatearr.length>self.templatepageSize){
          for(var y=0;y<self.templatepageSize;y++){
            self.clinicalTemplatesDispArr.push(templatearr[y]);
          }
        }
        else{
          templatearr.forEach(y=>{
            self.clinicalTemplatesDispArr.push(y);
          });
        }
      }
    },
    searchTemplate:function($event) {
      if ($event.target.value && $event.target.value.length >= 3) {
        //this.clinicalTemplatesDispArr = this.clinicalTemplates;
        //this.tertiaryslist = this.clinicalTemplates;
        var self = this;
        var searchterm = $event.target.value;
        self.clinicalTemplatesDispArr = [];
        var templatearr = JSON.parse(self.secondaryClinicalTempaltes);
        templatearr.forEach(xy => {
          if (searchterm) {
            var foundornot = false;
            let termposition = -1;
            if (xy) {
              //xy = this.trimHtml(xy);
              var nameExist = xy.name.toLowerCase().indexOf(searchterm.trim().toLowerCase()) > -1;
              if (nameExist) {
                //Check if the item is already selected or not
                
                if (termposition < 0) {
                  xy.name = Auth.highlightText(xy.name, searchterm.trim(),'#F1A31A');
                  self.clinicalTemplatesDispArr.push(xy);
                  console.log(self.clinicalTemplatesDispArr);
                }
              }
              foundornot = nameExist;
            } else {
              //xy = this.trimHtml(xy);
              foundornot =xy.name.toLowerCase().indexOf(searchterm.trim().toLowerCase()) > -1;
              if (foundornot) {
                // //Check if the item is already selected or not
                // if (this.symptomsselected_display && this.symptomsselected_display.length) {
                //   termposition = this.symptomsselected_display.indexOf(
                //     this.trimHtml(xy)
                //   );
                // }
                if (termposition < 0) {
                  xy.name = Auth.highlightText(xy.name, searchterm.trim());
                  self.clinicalTemplatesDispArr.push(xy);
                  console.log(self.clinicalTemplatesDispArr);
                }
              }
            }
           //self.highlightedlist;
            //return foundornot;
          } else {
            xy = this.trimHtml(xy);
            //self.highlightedlist = [];
            self.showDefaultNumberOfTemplates();
            //console.log("When nothing is there in search box",$event.target.value,self.highlightedlist);
            //return true;
          }
        });
        //self.showsearchdropdownpopup = self.highlightedlist.length > 0;
        //this.paginateList();
      } else {
        this.clinicalTemplatesDispArr = [];
        this.showDefaultNumberOfTemplates();
      }
    },
    trimHtml(htmlTxt) {
      var div = document.createElement("div");
      div.innerHTML = htmlTxt;
      return div.innerText;
    },
    copyDataToClipBoard(txt){
      this.clipBoardText = txt;
    },
    copyAll: function(items) {
      var self=this;
      if (tinyMCE && self.$parent.$data.activeeditr && self.$parent.$data.activeeditr.iframeHTML && self.$parent.$data.activeeditr.iframeHTML.includes('id="tinymce"')) {
        let oldData = self.$parent.activeeditr_old_content+"</br>";
        self.$parent.activeeditr_old_content=self.$parent.$data.activeeditr.contentWindow.document.body.innerHTML + "<p>"+items+"</p>";
        self.clipBoardText = items;
              var ed=tinyMCE.activeEditor;
      ed.selection.setContent("<p>"+items+"</p>");
           
      }      
      else if(tinyMCE && tinyMCE.activeEditor && self.$parent.$data.activeeditr && self.$parent.$data.activeeditr.id && self.$parent.$data.activeeditr.contentWindow && self.$parent.$data.activeeditr.contentWindow.document && self.$parent.$data.activeeditr.contentWindow.document.body && self.$parent.$data.activeeditr.id.indexOf("_ifr")>-1 && self.$parent.$data.activeeditr.id.split("_ifr")[0]===self.$parent.$data.activeeditr.contentWindow.document.body.getAttribute("data-id")){
        self.$parent.activeeditr_old_content=self.$parent.$data.activeeditr.contentWindow.document.body.innerHTML;
        self.clipBoardText = items;
       var ed=tinyMCE.activeEditor;
      ed.selection.setContent("<p>"+items+"</p>");
      }      
      else if(self.$parent.$data.activeeditr && self.$parent.$data.activeeditr.type==="textarea"){
        self.$parent.$data.activeeditr.value=self.$parent.$data.activeeditr.value+"\n"+items;
       self.$parent.$data.activeeditr.value.replace(/\n/g,'<br/>');
     self.$parent.activeeditr_old_content = self.$parent.$data.activeeditr.value;
        self.clipBoardText = items;
      }

    },
    deletetemplate:function(item){
      if(item){
        var user=JSON.parse(localStorage.loggedInUserInfo);
        var createduserid=user.unique_id;
        var roleid=user.role.unique_id;
        // if(user.selectedForms)
        // {
        //   user.selectedForms.forEach(y=>{
        //     if(!categoryid){
        //       categoryid=y.unique_id;  
        //     }
        //     else{
        //       categoryid=categoryid+','+y.unique_id;
        //     }
        //   });
        // }
        var self=this;
        Axios.request({
          method:'delete',
          url:rest_service.baseURL+"/clinicaldatatemplate/delcdtbyid?id="+item.unique_id+"&providerid="+item.provider_unique_id,
          headers: {
            x_tenant_id: localStorage.tenantid,
            role_unique_id: user.role.unique_id,
            route_entity_name: '/clinicaldatatemplate',
            loggedin_user_unique_id: user.unique_id,
            Authorization: localStorage.accesstoken
          }
        })
        .then(respo=>{
          if(respo && respo.data && respo.data===200 && respo.status===201){
            console.log(respo);
            self.sucessmsgtext = "Deleted successfully";
            self.isdisplaymsg = true;
            self.iserrormsg=false;
            setTimeout((xy)=>{self.closeMessage();},2000);
            self.getClinicaltemplates("", 0, false);
          }
        });
      }
    },
    confirmDelTemplate: function(item){
      console.log("confirmDelTemplate",item);
      this.showCnfrmPopUp = false;
      this.confrmPopUpResponse = false;
      if(item)
      {
        console.log("SAME USER?",item.created_by === this.loggedin_user_unique_id);
        var user=JSON.parse(localStorage.loggedInUserInfo);
        var createduserid=user.unique_id;
        if((item.created_by === createduserid)){
          this.recordToDelete = item;
          this.showCnfrmPopUp = true;
          this.actionMsg = "Are you sure you want to delete the selected template?";
        }
      }
    },
    closeMessage(){
      this.isdisplaymsg=false;
    },
    viewMoreTemplate(){
      var templatearr = JSON.parse(this.secondaryClinicalTempaltes);
      if(!this.showViewLess)
      {
        this.noOfClickOnViewMore+=1;
        this.showViewLess= templatearr.length<=(this.noOfClickOnViewMore * this.templatepageSize);
      }
      else
      {
        this.noOfClickOnViewMore-=1;
        this.showViewLess= this.noOfClickOnViewMore==1?false:true;
      }
      
      if(this.noOfClickOnViewMore>0){
        this.clinicalTemplatesDispArr=templatearr.slice(0,this.noOfClickOnViewMore*this.templatepageSize);
      }
      else{
        this.noOfClickOnViewMore=1;
        this.showViewLess= false;
      }
    },
    getVitals(){
      let rangekey;
      if (this.$route.query.range_key) {
        rangekey = this.$route.query.range_key;
      } else {
        rangekey = this.$route.query.encounter_id;
      }
      if (this.$route.query.patient_id && rangekey) {
        //this.$router.push({name:clinicalnotes,path: "/Vitals",query: {patient_id: this.$route.query.patient_id,range_key: rangekey}});
        //open pop-up
        this.openclosemodal=true;
      }
    }
  }
};
$(document).ready(function(){
  $(".toggle-menu").hover(
    function() {
      setTimeout(function() {
        $(".tooltip").addClass("customtooltipcomplaint");
      }, 0);
    },
    function() {}
  );
  $(".toggle-menu.toggle-menu-1").hover(function() {
    $(".tooltip").addClass("small");
  });
  $(".toggle-menu.toggle-menu-2").hover(function() {
    $(".tooltip").removeClass("small");
  });
});
</script>

<style>
#accordion{overflow-x: hidden;}
</style>
